
















import { Vue, Component } from 'vue-property-decorator';
import DashboardChart from './dashboard-chart.vue';
import DashboardRank from './dashboard-rank.vue';
import DashboardServices from '@/services/dashboard';
import { getRange } from '@/libs/time';
import DictMixin from '@/mixins/dict-mixin';
import { mixins } from 'vue-class-component';
import { sleep } from '@/libs/util';
@Component({
  components: { DashboardChart, DashboardRank }
})
export default class Full extends mixins(DictMixin) {
  dashSrv = new DashboardServices();
  bread = [{ name: '预警监控' }, { name: '预警仪表盘' }];

  created() {
    let [startTime, endTime] = getRange('week');
    this.getManagePlate({ startTime, endTime });
    this.getCustomerJourney({ startTime, endTime });
    this.getAllAlert({ startTime, endTime });
  }

  async getAllAlert(params?: any) {
    let res = await this.dashSrv.getAllAlert(params);
    this.listA = [
      { title: '累计预警件数', query: {}, total: res.allCount.total, red: res.allCount.oneLevelTotal, orange: res.allCount.twoLevelTotal, yellow: res.allCount.threeLevelTotal },
      {
        title: '累计待经办预警件数',
        query: { alertHandleStatus: 0 },
        total: res.handleCount.total,
        red: res.handleCount.oneLevelTotal,
        orange: res.handleCount.twoLevelTotal,
        yellow: res.handleCount.threeLevelTotal
      },
      {
        title: '累计待复核预警件数',
        query: { alertReviewStatus: 0 },
        total: res.reviewCount.total,
        red: res.reviewCount.oneLevelTotal,
        orange: res.reviewCount.twoLevelTotal,
        yellow: res.reviewCount.threeLevelTotal
      }
    ];
  }

  async getManagePlate(params?: any) {
    if (!this.DICT_BUSINESS_UNIT) {
      await sleep(100);
      this.getManagePlate(params);
      return false;
    }
    let list = await this.dashSrv.getManagePlate(params);
    this.listB = [];
    this.DICT_BUSINESS_UNIT.forEach((v: any) => {
      let item = (list||[]).find((l: any) => l.name === v.label);
      this.listB.push({
        title: v.label,
        total: item?.total ?? 0,
        query: { ruleOwnerPlate: v.value },
        red: item?.oneLevelTotal ?? 0,
        orange: item?.twoLevelTotal ?? 0,
        yellow: item?.threeLevelTotal ?? 0
      });
    });
  }

  async getCustomerJourney(params?: any) {
    if (!this.DICT_JOURNEY_SCENE) {
      await sleep(100);
      this.getCustomerJourney(params);
      return false;
    }
    let list = await this.dashSrv.getCustomerJourney(params);
    this.listC = [];
    this.DICT_JOURNEY_SCENE.forEach((v: any) => {
      let item = (list||[]).find((l: any) => l.name === v.label);
      this.listC.push({
        title: v.label,
        total: item?.total ?? 0,
        query: { ruleFirstLevel: v.value },
        red: item?.oneLevelTotal ?? 0,
        orange: item?.twoLevelTotal ?? 0,
        yellow: item?.threeLevelTotal ?? 0
      });
    });
  }

  changeDateA(date: string[]) {
    let [startTime, endTime] = date;
    this.getAllAlert({ startTime, endTime });
  }

  changeDateB(date: string[]) {
    let [startTime, endTime] = date;
    this.getManagePlate({ startTime, endTime });
  }

  changeDateC(date: string[]) {
    let [startTime, endTime] = date;
    this.getCustomerJourney({ startTime, endTime });
  }

  listA: any = [];

  listB: any = [];

  listC: any = [];
}
